import Editor from '@monaco-editor/react';
import { Button, Modal } from 'antd';
import React from 'react';
import styled from 'styled-components/macro';
import { jsonToYaml } from './utils';
import { useTranslation } from '../../../i18n/useTranslation';

const YamlWrapper = styled.div`
    padding: 24px;
`;

interface Props {
    recipe?: string;
    onCancel: () => void;
}

function RecipeViewerModal({ recipe, onCancel }: Props) {
    const { t } = useTranslation();
    const formattedRecipe = recipe ? jsonToYaml(recipe) : '';

    const handleCancel = () => {
        onCancel();
    };

    return (
        <Modal
            visible
            onCancel={handleCancel}
            className="f-modal"
            title={t('View Ingestion Recipe')}
            footer={
                <Button onClick={handleCancel} type="primary">
                    {t('Done')}
                </Button>
            }
        >
            <YamlWrapper className="f-pa-1-xs">
                <Editor
                    options={{
                        readOnly: true,
                        minimap: { enabled: false },
                        scrollbar: {
                            vertical: 'hidden',
                            horizontal: 'hidden',
                        },
                    }}
                    height="55vh"
                    defaultLanguage="yaml"
                    value={formattedRecipe}
                />
            </YamlWrapper>
        </Modal>
    );
}

export default RecipeViewerModal;
